module.exports = __webpack_public_path__ + "img/今日到货.svg";